import React, { useState } from "react";

const STEP = 0.01;

const displayPercent = (percentage) =>
  percentage == null
    ? ""
    : (Math.round(Number(percentage) * 10000) / 100).toString();

const PayoutTableCell = ({
  isEditing,
  quantity,
  order,
  matchingPayout,
  onPercentageChange,
  onKeyDown,
  dollarAmount = null,
  dollarWhole = true,
  invalid = false,
  rowBg = "bg-white",
  highlighted = false,
  floorMiss = false,
}) => {
  const storedPercent = matchingPayout?.percentage;
  const [inputValue, setInputValue] = useState(() =>
    displayPercent(storedPercent)
  );

  React.useEffect(() => {
    setInputValue(displayPercent(storedPercent));
  }, [storedPercent]);

  const commit = (value) => {
    setInputValue(value);
    onPercentageChange(parseInt(quantity, 10), order, value);
  };

  const handleInputChange = (e) => {
    commit(e.target.value);
  };

  const handleInputBlur = (e) => {
    const raw = e.target.value;
    if (raw !== "" && !Number.isNaN(parseFloat(raw))) {
      commit(parseFloat(raw).toFixed(2));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      const current = parseFloat(e.target.value);
      const base = Number.isFinite(current) ? current : 0;
      const next =
        e.key === "ArrowUp" ? base + STEP : base - STEP;
      const clamped = Math.min(100, Math.max(0, Math.round(next * 100) / 100));
      commit(clamped.toFixed(2));
      return;
    }
    onKeyDown?.(e, parseInt(quantity, 10), order);
  };

  const tone = invalid
    ? "bg-red-50"
    : floorMiss
      ? "bg-amber-100"
      : highlighted
        ? "bg-brand-gold/20"
        : rowBg;

  if (order > parseInt(quantity, 10)) {
    return <td className={`${tone} px-1 py-1.5`} aria-hidden="true" />;
  }

  return (
    <td
      className={`${tone} px-1 py-1.5 text-center font-score text-brand-charcoal tabular-nums`}
    >
      {isEditing ? (
        <div>
          <input
            type="number"
            step="0.01"
            min="0"
            max="100"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyDown}
            onFocus={(e) => e.target.select()}
            data-quantity={quantity}
            data-order={order}
            className="w-14 px-1 py-0.5 border border-brand-charcoal/20 rounded text-center font-score text-sm text-brand-charcoal bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
            placeholder="0"
            inputMode="decimal"
            aria-label={`${order} of ${quantity} places`}
          />
          {dollarAmount !== null ? (
            <div
              className={`text-[10px] leading-none mt-0.5 ${
                floorMiss ? "text-amber-900 font-medium" : "text-brand-muted"
              }`}
            >
              ${dollarWhole ? dollarAmount.toFixed(0) : dollarAmount.toFixed(2)}
            </div>
          ) : null}
        </div>
      ) : matchingPayout ? (
        <div>
          <div>
            {(Math.round(matchingPayout.percentage * 10000) / 100).toFixed(1)}
          </div>
          {dollarAmount !== null ? (
            <div
              className={`text-[10px] leading-none ${
                floorMiss ? "text-amber-900 font-medium" : "text-brand-muted"
              }`}
            >
              ${dollarWhole ? dollarAmount.toFixed(0) : dollarAmount.toFixed(2)}
            </div>
          ) : null}
        </div>
      ) : (
        <span className="text-brand-muted">-</span>
      )}
    </td>
  );
};

export default PayoutTableCell;
